import { workflowActions } from './workflow-dashboard.actions';

export const initialState = {
  changes: [],
  changesTotal: 0,
  changesPage: 1,
  isLoadingChanges: false,
  isSubmittingAction: false,
  notifications: [],
  notificationsTotal: 0,
  unreadCount: 0,
  permissions: [],
  history: [],
  isLoadingHistory: false,
  isDownloadingReport: false,
  downloadError: null,
  error: null,
};

export function workflowReducer(state = initialState, action) {
  switch (action.type) {
    case workflowActions.LOAD_CHANGES_REQUEST:
      return { ...state, isLoadingChanges: true };
    case workflowActions.LOAD_CHANGES_SUCCESS:
      return {
        ...state,
        isLoadingChanges: false,
        changes: (action.payload.response && action.payload.response.rows) || [],
        changesTotal: (action.payload.response && action.payload.response.total) || 0,
        changesPage: (action.payload.response && action.payload.response.page) || 1,
      };
    case workflowActions.LOAD_CHANGES_FAILURE:
      return { ...state, isLoadingChanges: false };

    case workflowActions.APPLY_ACTION_REQUEST:
    case workflowActions.BULK_ACTION_REQUEST:
    case workflowActions.ROLLBACK_REQUEST:
      return { ...state, isSubmittingAction: true };
    case workflowActions.APPLY_ACTION_SUCCESS:
    case workflowActions.ROLLBACK_SUCCESS:
      return { ...state, isSubmittingAction: false };
    // Keeps the payload. Since slice 5j the response carries a per-request outcome and a bulk can
    // partially succeed, so discarding it left the dashboard with nothing to report but the count it
    // had asked for.
    case workflowActions.BULK_ACTION_SUCCESS:
      return { ...state, isSubmittingAction: false, lastBulkResult: action.payload || null };
    case workflowActions.APPLY_ACTION_FAILURE:
    case workflowActions.BULK_ACTION_FAILURE:
    case workflowActions.ROLLBACK_FAILURE:
      return { ...state, isSubmittingAction: false };

    case workflowActions.LOAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: (action.payload.response && action.payload.response.rows) || [],
        notificationsTotal: (action.payload.response && action.payload.response.total) || 0,
      };

    case workflowActions.LOAD_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: (action.payload.response && action.payload.response.count) || 0,
      };

    case workflowActions.MARK_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.notification_id === action.payload.notificationId ? { ...n, is_read: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };

    case workflowActions.MARK_ALL_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
        unreadCount: 0,
      };

    case workflowActions.LOAD_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload.response || [],
      };

    case workflowActions.LOAD_HISTORY_REQUEST:
      return { ...state, isLoadingHistory: true };
    case workflowActions.LOAD_HISTORY_SUCCESS:
      return { ...state, isLoadingHistory: false, history: action.payload.response || [] };
    case workflowActions.LOAD_HISTORY_FAILURE:
      return { ...state, isLoadingHistory: false };

    case workflowActions.DOWNLOAD_AUDIT_REPORT_REQUEST:
    case workflowActions.DOWNLOAD_DETAILED_REPORT_REQUEST:
    case workflowActions.DOWNLOAD_SUMMARY_REPORT_REQUEST:
      return { ...state, isDownloadingReport: true, downloadError: null };
    case workflowActions.DOWNLOAD_AUDIT_REPORT_SUCCESS:
    case workflowActions.DOWNLOAD_DETAILED_REPORT_SUCCESS:
    case workflowActions.DOWNLOAD_SUMMARY_REPORT_SUCCESS:
      return { ...state, isDownloadingReport: false };
    case workflowActions.DOWNLOAD_AUDIT_REPORT_FAILURE:
    case workflowActions.DOWNLOAD_DETAILED_REPORT_FAILURE:
    case workflowActions.DOWNLOAD_SUMMARY_REPORT_FAILURE:
      return { ...state, isDownloadingReport: false, downloadError: action.payload };

    default:
      return state;
  }
}
